import React, { useCallback } from 'react';
import LayoutWithMap from 'containers/Base/LayoutWithMap.jsx';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  detailOpenState,
  getCurrentPage,
  modalState,
  toggleModal,
} from 'reducers/ui';
import {
  visitorTypeFilters,
  visitorTypeActions,
  visitorTypeSelectors,
  visitorTypeFilterActions,
  visitorTypeNS,
} from 'containers/Pages/Locations/VisitorTypes';
import useFilters from 'containers/Base/useFilters.js';

const VisitorTypes = ({
  columns,
  filtersRequired,
  editable,
  loading,
  details,
  FormComponent,
}) => {
  const pageUrl = useSelector(state => getCurrentPage(state));
  const detailOpen = useSelector(state => detailOpenState(state));
  const modalOpen = useSelector(state => modalState(state));
  const visitorTypeListData = useSelector(state =>
    visitorTypeSelectors.getVisitorTypeListTransformed(state),
  );
  const numRows = useSelector(state =>
    visitorTypeSelectors.getTotalEntries(state),
  );
  const filterValues = useSelector(state =>
    visitorTypeSelectors.getFilters(state),
  );
  const forceRefresh = useSelector(state =>
    visitorTypeSelectors.getForceRefresh(state),
  );
  const dispatch = useDispatch();
  const dispatchFetchVisitorTypeList = useCallback(
    ({ filters, from }) =>
      dispatch(visitorTypeActions.fetchGridList({ filters, from })),
    [dispatch],
  );
  //--------------------------customHooks--------------------------
  const { localFilterValues, updateFilter } = useFilters({
    filterValues,
  });
  const fetchVisitorTypes = from => {
    dispatchFetchVisitorTypeList({ filters: localFilterValues, from });
  };
  const onUpdate = () => {
    dispatchFetchVisitorTypeList({ filters: localFilterValues });
  };
  const VisitorTypeFormComponent = useCallback(
    props => <FormComponent {...props} />,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  const dispatchToggleModal = useCallback(
    () => dispatch(toggleModal(visitorTypeNS)),
    [dispatch],
  );
  return (
    <LayoutWithMap
      header={'Visitor Types'}
      cols={columns}
      loading={loading}
      DetailComponent={details}
      editable={editable}
      FormComponent={VisitorTypeFormComponent}
      toggleModal={dispatchToggleModal}
      onEdit={modalOpen[visitorTypeNS]}
      //filters
      filtersRequired={filtersRequired}
      filterValues={localFilterValues}
      filters={visitorTypeFilters()}
      setFilters={(values, hasApplyFilter) =>
        updateFilter({
          values,
          hasApplyFilter,
          applyFilter: filters => {
            visitorTypeFilterActions.setFilterKey({ key: true });
            visitorTypeFilterActions.setFilters({ filters });
          },
        })
      }
      forceOpenDetailPanel={detailOpen[pageUrl]}
      forceRefresh={forceRefresh}
      onUpdate={onUpdate}
      data={visitorTypeListData}
      fetchData={fetchVisitorTypes}
      totalEntries={numRows}
    />
  );
};
VisitorTypes.propTypes = {
  columns: PropTypes.array.isRequired,
  details: PropTypes.func.isRequired,
  filtersRequired: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  editable: PropTypes.bool,
  FormComponent: PropTypes.elementType,
};
export default VisitorTypes;
